import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseEvidenceDownloadComponent } from '../base-evidence-download/base-evidence-download.component';
import { Observable, of } from 'rxjs';
import { DownloadEvidenceParams } from '@anecdotes/shared-trust-center';
import { EvidenceTypeEnum } from '@anecdotes/api-contracts';

@Component({
  selector: 'app-download-or-request-access-button',
  templateUrl: './download-or-request-access-button.component.html',
  styleUrls: ['./download-or-request-access-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DownloadOrRequestAccessButtonComponent extends BaseEvidenceDownloadComponent implements OnChanges, OnInit {
  @Input({ required: true })
  evidences: DownloadEvidenceParams[];

  canDownloadEvidence$: Observable<boolean>;

  isUrlEvidence: boolean;

  get areAllFilesPrivate(): boolean {
    return this.evidences.every(({ is_public }) => !is_public);
  }

  get hasOneFile(): boolean {
    return this.evidences.length === 1;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('evidences' in changes && !changes.evidences.firstChange) {
      this.initializeValues();
    }
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.initializeValues();
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  private initializeValues(): void {
    this.canDownloadEvidence$ = this.hasOneFile ? this.canDownloadEvidence(this.evidences[0]) : of(false);
    this.isUrlEvidence = this.hasOneFile ? this.evidences[0].evidence_type === EvidenceTypeEnum.URL : false;
  }
}
